import { instiRoutehandle } from './../../insti/instiRoutehandle.module';
import * as $ from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  Output, EventEmitter
} from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { AppHeaderComponent } from './header/header.component';
import { AppSidebarComponent } from './sidebar/sidebar.component';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { InstiService } from '../../insti/insti.service';
import { instiLoading } from '../../insti/instiLoading.module';
/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: []
})
export class FullComponent implements OnDestroy, AfterViewInit {
  
  @ViewChild('snav', {static: false}) sidenav:any;

  mobileQuery: MediaQueryList;
  dir = 'ltr';
  green: boolean;
  blue: boolean;
  dark: boolean;
  minisidebar: boolean;
  boxed: boolean;
  danger: boolean;
  yellow: boolean;
  showHide: boolean;
  sidebarOpened;
 // @Output() is_loading: EventEmitter<any> = new EventEmitter();
  exibirMenu = false;
  is_loading: boolean=false;
  loadObj: instiLoading;
  chg_detect:ChangeDetectorRef;
  
  public config: PerfectScrollbarConfigInterface = {};
  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    protected service: InstiService,
    protected insti_route:instiRoutehandle,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this.yellow = true;
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.exibirMenu = this.service.getUser().getData()['tipo'] == 4 ? false : true;
    this.chg_detect=changeDetectorRef;
    this.loadObj=new instiLoading();
    this.setIsLoading(true);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  ngAfterViewInit() {
      /**
       * ALUISIO FERREIRA DE SOUSA
       * Force change detection
       */
       this.chg_detect.detectChanges();
    // This is for the topbar search
    (<any>$('.srh-btn, .cl-srh-btn')).on('click', function() {
      (<any>$('.app-search')).toggle(200);
    });
    // This is for the megamenu
  }

  gotoHome(){
    this.insti_route.getRoutObj().navigate([this.service.getHomeUrl(true)]);
  }

  toggleSidenav()
  {
    this.sidenav.toggle();
  }
  getIsLoading(){
    let a=this.loadObj.getIsLoading();
    this.is_loading=a;     
    return a; 
  }
  setIsLoading(value: boolean){ 
      this.is_loading=value;    
      this.loadObj.setIsLoading(value);
      //this.is_loading.emit(this.loadObj.getIsLoading());     
       return this;
   }
   onActivate(componentReference) {
        if(!componentReference.hasOwnProperty('is_loading')){
          return this;  
        }
        let instance= this;
        componentReference.is_loading.subscribe((data) => {
             instance.setIsLoading(data);     
        });  
 }
 private montaMenuItensRules(){
     let menu_arr=this.menuItems.getMenuitem();
     let limit=menu_arr.length;
     let x=0;
     let filtereds:any[]=[];
     for(x=0; x<limit; x++){
         let atual=filtereds[x];
          if(atual.hasOwnProperty('')){
             
         }
     }
     
 }
  // Mini sidebar
}
 